export default "__VITE_ASSET__Bhs00ieQ__"